import { render } from "./ShippingTypes.vue?vue&type=template&id=204d2ffa&ts=true"
import script from "./ShippingTypes.vue?vue&type=script&lang=ts"
export * from "./ShippingTypes.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\source-ali\\Order-Management\\OrderManagement-Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__